import Highcharts from 'highcharts'
import addNoDataToDisplay from 'highcharts/modules/no-data-to-display';
addNoDataToDisplay(Highcharts)

Highcharts.setOptions({
  title: { style: { fontSize: '20px' } },
  subtitle: { style: { fontSize: '15px' } },
  legend: { itemStyle: { fontSize: '13px' } },
  xAxis: { labels: { style: { fontSize: '13px' } } },
  yAxis: {
    title: { text: '' },
    labels: { style: { fontSize: '13px' } },
    stackLabels: { style: { fontSize: '13px' } },
  },
  plotOptions: {
    series: { dataLabels: { style: { fontSize: '13px' } } },
  },
  caption: {
    align: 'center',
    style: {
      fontSize: '13px',
      fontWeight: 'bold',
    },
    verticalAlign: 'middle',
  },
  lang: {
    noData: 'データがありません',
    thousandsSep: ',',
  },
  noData: { style: { fontSize: '13px' } },
});

export default Highcharts
